// import React from 'react';

// function FinalAccountList() {
//   // const powerBiUrl = "https://app.powerbi.com/reportEmbed?reportId=92d3b3ea-4315-41b6-ae1e-139948f40e90&autoAuth=true&ctid=b161c897-0ae2-42a0-be86-8f7e36f2049f";
//   const powerBiUrl = process.env.REACT_APP_Final_Acc_Closure;

//   return (
    
//       <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>
    
//   );
// }

// export default  FinalAccountList;

import React,{ useEffect, useState } from 'react';
import { queuedApiFetch } from '../api';

function FinalAccountList() {
    const [powerBiUrl, setPowerBiUrl] = useState('');
    const url_name='Final_Acc_Closure';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const requestOptions = { method: 'GET' };
                const data = await queuedApiFetch(
                    `/project/get_powerbi_url?url_name=${url_name}`,
                    requestOptions
                );

                if (
                    data?.apistatus?.Status_Code === 200 &&
                    data?.apistatus?.Status_Description?.toLowerCase() === 'success'
                ) {
                    setPowerBiUrl(data.data); 
                } else {
                    console.error('Failed to load Power BI URL');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } 
        };

        fetchData();
    }, []);


    return (

        <iframe title="Power BI Report" src={powerBiUrl} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

    );
}

export default FinalAccountList;
